import tracker from '../tracking/Tracker';

export function trackClick(variationId: string) {
  tracker.trackOnNextPageImpression({ product_UpsellingClicked: 'true' });
  tracker.submitClickEvent({ product_Upselling: 'clicked' }, variationId);
}
